module.exports = __webpack_public_path__ + "static/media/DropDownGreen.940dd08d.svg";